import React, { useState, useRef, useEffect } from 'react'
import PropTypes from "prop-types";
import Dropzone from '../Posts/Dropzone';
import { DirectUpload } from '@rails/activestorage';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import { HTTP } from '../../api/resources';
import PostUploadsBlock from "../Posts/PostUploadsBlock/PostUploadsBlock";
import update from "immutability-helper";

function Upload(props) {
  const user = props.user
  const groupPost = props.group_post
  const inputFiles = useRef(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false)
  const [orderedUploads, setOrderedUploads] = useState([])
  const backendForDnD = "ontouchstart" in window ? TouchBackend : HTML5Backend;
  const [files, setFiles] = useState(orderedUploads);
  const fileFormats = [
    'image/*',
    'video/*',
    '.doc',
    '.docx',
    '.pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ].join()

  useEffect(() => {
    if (groupPost.images) {
      setFiles(groupPost.images)
    }
  }, [])

  // Save the files meta data to the model
  const uploadMedia = async () => {
    setLoading(true)

    // ensure file length is greater than 1
    if (files.length < 1) {
      Alert.show('notice', 'You have to add a minimum of 1 media file')
      setLoading(false)
      return ''
    }

    try {
      await saveFiles()
    } catch {
      Alert.show('error', 'Failed to save media, try again')
      setLoading(false)
      return ''
    }

    setLoading(false)
    Alert.show('notice', 'Media saved successfully')
    setTimeout(() => window.location = '/group/post/form', 1500)
  }

  const onFilesChange = async (files) => {
    setFileUploading(true)

    const uploadPromises = Array.from(files).map(file => uploadFile(file))

    await Promise.allSettled(uploadPromises)

    setFileUploading(false)
  }


  const onDrop = (acceptedfiles) => {
    Array.from(acceptedfiles).forEach(file => {
      uploadFile(file)
    })
  }

  // upload files to file view
  const uploadFile = (file) => {
    return new Promise((resolve, reject) => {
      const upload = new DirectUpload(file, '/api/v1/direct_uploads');
      upload.create((error, blob) => {
        if (error) {
          Alert.show("error", "Could not update. Try again.");
          reject(error)
        } else {
          setFiles(prevArray => [...prevArray, blob])
          resolve(blob)
        }
      })
    })
  }

  // remove files from file view
  const removeFile = (file) => {
    let filesClone = [...files]; // make a separate copy of the array
    _.remove(filesClone, { signed_id: file.signed_id })
    setFiles(filesClone);
    Alert.show("notice", "File removed!");
  }

  // move files in the file view
  const moveFile = (dragIndex, hoverIndex) => {
    const draggedFile = files[dragIndex];
    setFiles(
      update(files, {
        $splice: [[dragIndex, 1], [hoverIndex, 0, draggedFile]]
      })
    );
  };

  const saveFiles = (data) => {
   return HTTP.patch('/group/post/media', {images: files})
  }



  return (
    <div>
      <div className="page-header">
        <h4 className="page-title">
          Upload All Media Files
        </h4>

        <div className="page-actions show-mobile">
          <div className="btn-group">
                <button
                  onClick={uploadMedia}
                  name="button"
                  className="btn btn-primary"
                  type="button">
                  {loading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                  Proceed
                </button>
            </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header flex-header">
          <div>
            <h4 className="card-title">
              Files <small>(images / documents)</small>
            </h4>
            <p>Supported formats: .jpg/jpeg, .png, .pdf, .doc, .docx, .mp4 </p>
            <p>Upload all the media files you intend to use in your posts</p>
          </div>
          <div>

            <input ref={inputFiles} id="uploader" type="file" multiple accept={fileFormats}
              onChange={e => {
                setIsDirty(true)
                return onFilesChange(e.currentTarget.files)}}
              direct_upload="true"
              className="d-none"
            />

            <button onClick={() => inputFiles.current.click()} name="button" className="btn btn-primary">
              {fileUploading && (<span><i className="fa fa-spinner-third fa-spin mr-2"></i> Uploading</span>)}
              {!fileUploading && (<span><i className="fa fa-plus mr-2"></i> Upload</span>)}
            </button>

          </div>
        </div>

        <div className="card-body">
          {files.length == 0 && (
            <>
            <p>No files uploaded yet</p>
            <Dropzone accept={fileFormats} onDrop={onDrop} />
            </>
          )}
          <DndProvider backend={backendForDnD}>
            <PostUploadsBlock isDraggable={true} fileFormats={fileFormats} uploads={files} moveFile={moveFile} removeFile={removeFile} />
          </DndProvider>
        </div>
      </div>
    </div>
  )
}

export default Upload
